import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getRootObjects } from '../../util/sceneObjectHierarchy';
export const StageLayer = React.memo(function StageLayer({ layer, objects, renderObject, zIndex }) {
    const roots = getRootObjects(objects);
    return (_jsx("div", { className: `stage-layer ${!layer.visible ? 'hidden' : ''} ${layer.locked ? 'locked' : ''}`, "data-layer-id": layer.id, style: { zIndex }, children: roots.map((obj) => (_jsx(React.Fragment, { children: renderObject(obj) }, obj.id))) }));
});
